import { ref } from 'vue'
import { defineStore } from 'pinia'

export const usePromiseStore = defineStore('promise', () => {
  const passwordPromise = ref(null)

  function setPasswordPromise(promise) {
    if (!passwordPromise.value) {
      passwordPromise.value = promise.finally(() => {
        passwordPromise.value = null
      })
    }
    return passwordPromise.value
  }

  return {
    setPasswordPromise,
    passwordPromise,
  }
})
